export default __webpack_public_path__ + "static/media/saveFavIcon.8582d45b.svg";